/* eslint-disable */
import RoleAdmin from './state';
export default {
  RoleAdmin,
};
